var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ofc-menu d-card py-3 px-3"},[(_vm.offices.length > 0)?_c('company-menu'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }